import React from "react";
import {Controller} from 'react-hook-form'
import {Label, Input} from 'reactstrap'
import ValidationMsgComponent from "../ValidationMsgComponent";

/**
 * Component -> Controlled CheckBox Field
 * @param label Input name for label
 * @param inputName input field name
 * @param placeholder placeholder for the input field
 * @param invalid whether input contain validation errors (boolean)
 * @param control control object of react-hook-form
 * @param errors validation errors object of react-hook-form
 * @param rules validation rules
 * @returns
 */

const ControlledCheckBoxField = ({label, inputName, placeholder, invalid, control, errors, rules, isDisabled}) => {

    return (
        <>
            <div className='form-check'>
                <Controller
                    name={inputName}
                    control={control}
                    rules={rules}
                    render={({field}) => (
                        <Input
                            id={inputName}
                            type="checkbox"
                            placeholder={placeholder}
                            invalid={invalid}
                            {...field}
                            defaultChecked={control._defaultValues[inputName]}
                            disabled={isDisabled}
                        />
                    )}
                />
                <Label className='form-label' htmlFor={inputName}>
                    {label}
                </Label>
            </div>
            {invalid && <ValidationMsgComponent inputName={inputName} invalid={invalid} errors={errors} rules={rules}/>}
        </>

    )
}

export default ControlledCheckBoxField
